<template lang="pug">
.page
  section
    .max-width
      .row.center
        .col
          .information-wrapper
            img.logo(src="../../assets/images/logo-white-text.svg")
            p You've got mail. Check your email and click the verify link.
</template>

<script>


export default {
  name: 'Verify',
  beforeMount() {
    if (this.$route.params.token) {
      this.$store.dispatch('user/verify', {
        token: this.$route.params.token
      }).then(data => {
        let url = process.env.NODE_ENV === 'development' ? `http://${data.redirectDomain}.feature.watch:3000`: `https://${data.redirectDomain}.feature.watch`
        if (data.isMember) {
          url += '/admin'
        }
        if (data.showOnboarding) {
          url += '/welcome'
        }
        window.location.href = url
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.page
  margin 0 auto
.information-wrapper
  padding $spacing-3
  .logo
    height 36px
    margin-bottom $spacing-3
    max-width 100%
  p
    color $color-black-lighter
    font-size 18px
    line-height 24px

</style>
